import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import SellerPackages from './seller/SellerPackages';
import AgencyPackages from './agency/AgencyPackages';

type Props = {
  taraSubscriptionPackages: any[];
};

const SubscriptionPackages = ({ taraSubscriptionPackages }: Props) => {
  const userRole: 'seller' | 'agency' =
    useSelector((state: RootState) => state.user?.profile?.role) === 'agency'
      ? 'agency'
      : 'seller';

  return (
    <div>
      {userRole === 'seller' ? (
        <SellerPackages taraSubscriptionPackages={taraSubscriptionPackages} />
      ) : (
        <AgencyPackages taraSubscriptionPackages={taraSubscriptionPackages} />
      )}
    </div>
  );
};

export default SubscriptionPackages;
